import { render, staticRenderFns } from "./WebsiteManageImageTiles.vue?vue&type=template&id=4dd60a96"
import script from "./WebsiteManageImageTiles.vue?vue&type=script&lang=js"
export * from "./WebsiteManageImageTiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports